import pathify from "vuex-pathify"
// https://davestewart.github.io/vuex-pathify/#/
export default pathify

pathify.options.cache = false
pathify.options.mapping = "standard" 